// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__R_OJH","input":"Login_input__up5dC","button":"Login_button__24OIW"};